import Step0BasicInfo from '../contact-info-form/step0BasicInfo'
import Step1NonVerifiedUser from '../contact-info-form/step1NonVerifiedUser'
import Step2EmailVerification from '../contact-info-form/step2EmailVerification'
import Step3LocationVerification from '../contact-info-form/step3LocationVerification'

export default {
    name: 'ContactInfo',
    components: {
        Step0BasicInfo,
        Step1NonVerifiedUser,
        Step2EmailVerification,
        Step3LocationVerification
    },
    data() {
        return {
            contactInfoFormStep: [
                {
                    id: '',
                    name: 'Basic Info',
                    order: 1
                },
                {
                    id: '',
                    name: 'Non-Verified Users',
                    order: 2
                },
                {
                    id: '',
                    name: 'Email Verification',
                    order: 3
                },
                {
                    id: '',
                    name: 'Location Verification',
                    order: 4
                }
            ],
            currentStep: 0,
            loading: false,
            organizationId: Number(this.$route.params.organizationId) || 0,
        }
    },
    methods: {
        saveAndGo(goTypeFn, step = null) {
            if(this.currentStep === 0) {
                this.saveStep0BasicInfo(goTypeFn.name).then(resp => {
                    if (resp) {
                        goTypeFn(step)
                        this.loading = false
                    }
                }).catch(error => {
                    this.loading = false
                })
            } else{
                goTypeFn(step)
            }
        },
        previousStep() {
            if (this.currentStep > 0) {
                this.currentStep--
            }
        },
        exit() {
            this.$router.push({ name: 'noti_Provider' })
        },
        nextStep() {
            if (this.currentStep < this.contactInfoFormStep.length - 1) {
                this.currentStep++
            }
        },
        changeStep(step) {
            if (!isNaN(step) && step >= 0 && step <= 3 && this.currentStep !== step) {
                this.currentStep = step
            }
        },
        saveStep0BasicInfo() {
            return new Promise((resolve, reject) => {
                this.$refs.step0BasicInfo.save().then(resp => {
                    if (resp) {
                        resolve(resp)
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        }
    },
}
